var uncurryThis = require('../internals/function-uncurry-this');

module.exports = uncurryThis({}.isPrototypeOf);



//////////////////
// WEBPACK FOOTER
// /var/www/html/wp-content/themes/sage/node_modules/simplebar/node_modules/core-js/internals/object-is-prototype-of.js
// module id = 55
// module chunks = 0